import React from 'react';
import { ArcAlert, ArcText } from '@src/core/ui';
import { useFlightProvider } from '@src/features/order/provider';
import { EnRouteFlightModeProps } from './types';

const EnRouteFlightMode: React.FC<EnRouteFlightModeProps> = (props) => {
  const { missionId } = props;
  const { flightMode } = useFlightProvider();

  if (!flightMode || missionId !== flightMode.missionId) return null;

  return (
    <ArcAlert severity='info'>
      <ArcText.h6 color='info.main'> {flightMode.value} </ArcText.h6>
    </ArcAlert>
  );
};

export default EnRouteFlightMode;